class EvermarkdPackQuantity extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    for (const event of ['input', 'change', 'quantity-selector:update']) this.addEventListener(event, this.#update, {signal: this.#controller.signal});
    this.#update();
  }
  disconnectedCallback() { this.#controller?.abort(); }
  #update = () => {
    const input = this.querySelector('input[type="number"]');
    const output = this.querySelector('[data-pack-total]');
    const size = Number(this.dataset.packSize);
    const quantity = Number(input?.value);
    if (!output || !Number.isInteger(size) || size < 1) return;
    output.hidden = !Number.isInteger(quantity) || quantity < 0;
    if (!output.hidden) output.textContent = (this.dataset.totalTemplate || '').replace('__total__', String(quantity * size));
  };
}
if (!customElements.get('evermarkd-pack-quantity')) customElements.define('evermarkd-pack-quantity', EvermarkdPackQuantity);
